import { DAY_LABELS, dayEnabled, toggleDay } from '@/lib/config'

/** Переключатель дней недели поверх битовой маски. */
export function DaysPicker({
  mask,
  onChange
}: {
  mask: number
  onChange: (next: number) => void
}): React.JSX.Element {
  return (
    <div className="days">
      {DAY_LABELS.map((label, i) => {
        const on = dayEnabled(mask, i)
        return (
          <button
            key={label}
            type="button"
            className={`day-chip${on ? ' is-on' : ''}`}
            aria-pressed={on}
            onClick={() => onChange(toggleDay(mask, i))}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
